import { render, staticRenderFns } from "./ContactSettings.vue?vue&type=template&id=5b1f0372"
import script from "./ContactSettings.vue?vue&type=script&lang=js"
export * from "./ContactSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports